import './header.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GECKO_UTILS } from '@geckolabs/gecko-react-ui';
import Utils from '../../services/utils/utils';

export class Header extends Component {

    defaultHeaderImage = 'images/default-header.jpg';
    
    windowWidth = null;

    UNSAFE_componentWillMount() {
        this.getWindowSize();   
    }

    /** 
     * Get the window size so the CDN can resize the
     * hero image on the fly to fit the users device.
     * 
     * @returns {void}
     */
    getWindowSize() {
        // This should only be called once on mount
        // so we dont download a new resized image
        // everytime the browser resizes.
        if (this.windowWidth) return;

        this.windowWidth = Math.floor(window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth);
    }

    account() {
        return this.props.account;
    }

    styles(){
        if (this.props.background || this.props.color) {
            return {
                banner: {
                    backgroundImage: `url(${Utils.appendSizeToImageUrl(this.props.background, this.windowWidth)})`, 
                    backgroundSize: 'cover',
                    backgroundColor: `${!this.props.background ? this.props.color : null}`
                },
                bannerMask: {
                    background: this.props.background ? `${this.props.color}b3` : null
                },
                logoContainer: {
                    color: GECKO_UTILS.getContrastColor(this.props.color)
                }
            };
        }

        return {
            banner: {
                backgroundImage: `url(${Utils.appendSizeToImageUrl(this.account().header_bg || this.defaultHeaderImage, this.windowWidth)})`, 
                backgroundSize: 'cover',
            },
            bannerMask: {
                background: this.account().color
            },
            logoContainer: {
                color: GECKO_UTILS.getContrastColor(this.account().color)
            }
        };
    }

    renderLogo() {
        const event = this.props.events && this.props.events.length ? this.props.events.find(e => !e.parent_id) : {};
        if (this.account().header_logo) return <img src={this.account().header_logo} className="logo" alt={event.title} />;
        return null;
    }

    render() {
        return (
            <div className="Header text-center">
                <div className="logo-container" style={this.styles().logoContainer}>
                    <div>
                        {this.renderLogo()}
                    </div>
                </div>
                <div className="banner-container">
                    <div className="banner" style={this.styles().banner}></div>
                    <div className="banner-mask" style={this.styles().bannerMask}></div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        account: store.account,
        contact: store.contact,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);
